<template>
  <div>
    <div class="stockSetting">
      <p>
        内容を入力して保存してください。（<span class="hissu">*</span>印は必須項目です。）
      </p>
      <ValidationObserver ref="observer" tag="form">
        <table class="table">
          <tbody>
            <tr>
              <td class="w200">拠点コード<span class="hissu">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }" rules="required|numeric|min_value:1|max_value:127">
                  <input type="text" id="inventory_sectionCode" :name="itemName.sectionCode"
                    class="inventory must form-control dataInput2" autocomplete="off"
                    v-model="entity.sectionCodeNumber" :readonly="isReadonly('sectionCodeNumber')" /> 番目
                    <div style="float:right;font-size:10px;width:90px;padding:5px;">半角英数字<br>16文字まで</div>
                  <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td class="w200">個体識別コード</td>
              <td>
                <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                  <input id="inventory_individualCodeNumber" type="text" :name="itemName.individualCode"
                    class="inventory form-control dataInput2" autocomplete="off"
                    v-model="entity.individualCodeNumber" :readonly="isReadonly('individualCodeNumber')" /> 番目
                    <div style="float:right;font-size:10px;width:90px;padding:5px;">半角英数字・記号<br>30文字まで</div>
                  <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>商品コード<span class="hissu">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }" rules="required|numeric|min_value:1|max_value:127">
                  <input id="inventory_goodsCodeNumber" type="text" :name="itemName.goodsCode"
                    class="inventory must form-control dataInput2" autocomplete="off"
                    v-model="entity.goodsCodeNumber" :readonly="isReadonly('goodsCodeNumber')" /> 番目
                    <div style="float:right;font-size:10px;width:90px;padding:5px;">半角<br>30文字まで</div>
                  <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>商品名<span class="hissu">*</span></td>
              <td>
                <ValidationProvider v-slot="{ errors }" rules="required|numeric|min_value:1|max_value:127">
                  <input id="inventory_goodsNameNumber" type="text" :name="itemName.goodsName"
                    class="inventory must form-control dataInput2" autocomplete="off"
                    v-model="entity.goodsNameNumber" :readonly="isReadonly('goodsNameNumber')" /> 番目
                    <div style="float:right;font-size:10px;width:90px;padding:10px;">50文字まで</div>
                  <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>数量</td>
              <td>
                <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                  <input id="inventory_quantityNumber" type="text" :name="itemName.quantity"
                    class="inventory form-control dataInput2" autocomplete="off"
                    v-model="entity.quantityNumber" :readonly="isReadonly('quantityNumber')" /> 番目
                    <div style="float:right;font-size:10px;width:90px;padding:5px;">半角数字<br>1~999999</div>
                  <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>JANコード</td>
              <td>
                <ValidationProvider v-slot="{ errors }" rules="numeric|min_value:1|max_value:127">
                  <input id=" inventory_janCodeNumber" type="text" :name="itemName.janCode"
                    class="inventory form-control dataInput2" autocomplete="off"
                    v-model="entity.janCodeNumber" :readonly="isReadonly('janCodeNumber')" /> 番目
                    <div style="float:right;font-size:10px;width:90px;padding:5px;">半角数字<br>14文字まで</div>
                  <br><span class="errMsg" :class="{ displayNone: errors.length === 0 }">{{ errors[0] }}</span>
                </ValidationProvider>
              </td>
            </tr>
            <tr>
              <td>ヘッダレコード有無<span class="hissu">*</span></td>
              <td>
                <input id="radio00" type="radio" name="inventoryHeaderExist" :value="1"
                  v-model="entity.headerExist" :disabled="isReadonly('headerExist')" />
                <label for="radio00" class="mr20">無し</label>
                <input id="radio01" type="radio" name="inventoryHeaderExist" :value="0"
                  v-model="entity.headerExist" :disabled="isReadonly('headerExist')" />
                <label for="radio01" class="mr20">有り</label>
              </td>
            </tr>
          </tbody>
        </table>
      </ValidationObserver>
      <button id="saveInventoryBtn" class="btn btn-lg btn-primary w200" style="margin-top:0;"
        :class="this.permissionData.saveBtn[this.$session.get('userDiv')]" @click="save">
        保存
      </button>
    </div>
    <!-- /.stockSetting -->
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'stock-data-set-inventory-num-table',

  components: {
    ValidationObserver,
    ValidationProvider
  },

  data () {
    return {
      permissionData: {},
      entity: {
        sectionCodeNumber: '',
        individualCodeNumber: '',
        goodsCodeNumber: '',
        goodsNameNumber: '',
        quantityNumber: '',
        janCodeNumber: '',
        headerExist: 1
      },
      itemName: {},
      mode: 'entry',
      message: null
    }
  },
  watch: {
    entity: {
      handler: function () {
        this.$emit('setInvNumber', this.entity)
      },
      deep: true
    }
  },
  async created () {
    this.$emit('setMessage', null, false)
    this.permissionData = this.permission().stockDataSet['entry']
    this.itemName = this.item()
    // 棚卸対象CSV取込設定（取得）API
    var response = await this.axios.get('/api/csv/get', {
      headers: {
        'Authorization': this.$session.get('accessToken'),
        'Content-Type': 'application/json;charset=UTF-8',
        'Access-Control-Allow-Origin': '*'
      }
    })
    if (response.data) {
      this.mode = 'update'
      this.entity = response.data
      for (var key in this.entity) {
        if (key === 'headerExist') {
          continue
        }

        if (this.entity[key] === 0) {
          this.entity[key] = ''
        }
      }
    }
  },

  methods: {
    isReadonly (item) {
      return this.permissionData[item][this.$session.get('userDiv')] === 'readonly'
    },
    async save () {
      this.$emit('setMessage', null, false)
      const isValid = await this.$refs.observer.validate()
      if (!isValid) {
        return
      }

      // 棚卸対象CSV取込設定（取得）API
      await this.axios.post('/api/csv/' + this.mode, this.entity, {
        headers: {
          'Authorization': this.$session.get('accessToken'),
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }).then((response) => {
        this.$emit('setMessage', '保存処理が完了しました。', false)
        this.mode = 'update'
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>



// WEBPACK FOOTER //
// src/components/pages/StockDataSetInventoryNumTable.vue